import { render } from "./SwiperPicture.vue?vue&type=template&id=06c6e738"
import script from "./SwiperPicture.vue?vue&type=script&lang=js"
export * from "./SwiperPicture.vue?vue&type=script&lang=js"

import "./SwiperPicture.vue?vue&type=style&index=0&id=06c6e738&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__